module.exports = __webpack_public_path__ + "static/media/jardin_terrasse.068582a5.jpg";